import { useCallback, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// Lightbox state lives in ?photo=<id>: browser Back closes it, links can open a photo.
export const usePhotoParam = (feed) => {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const pushed = useRef(false);
  const pid = params.get("photo");
  const idx = pid ? feed.items.findIndex((i) => i.id === pid) : -1;
  const { hasMore, loading, loadMore } = feed;
  useEffect(() => {
    if (pid && idx < 0 && hasMore && !loading) loadMore();
  }, [pid, idx, hasMore, loading, loadMore]);
  const withPhoto = useCallback((id) => {
    const p = new URLSearchParams(window.location.search);
    if (id) p.set("photo", id); else p.delete("photo");
    return p;
  }, []);
  const open = useCallback((id) => { pushed.current = true; setParams(withPhoto(id)); }, [setParams, withPhoto]);
  const setIndex = useCallback((i) => {
    if (feed.items[i]) setParams(withPhoto(feed.items[i].id), { replace: true });
  }, [feed.items, setParams, withPhoto]);
  const close = useCallback(() => {
    if (pushed.current) { pushed.current = false; navigate(-1); } else setParams(withPhoto(null), { replace: true });
  }, [navigate, setParams, withPhoto]);
  return { index: pid && idx >= 0 ? idx : null, open, setIndex, close };
};
